import { Button, Table } from "antd";
import { useEffect, useState } from "react";
import { useLazyGetSearchEmployeesQuery } from "../../store/api/employeeApi";
import { ColumnType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/paths";
import { Employee } from "../../types/employee.type";

import { FileExcelOutlined } from "@ant-design/icons";
import {
  DownloadExcelParams,
  useLazyDownloadExcelQuery,
} from "../../store/api/downloadApi";
import { useDatePickerColumn } from "../../components/useDatePickerColumn";
import { useSearchColumn } from "../../components/useSearchColumn";
import {
  useGetIikoRolesQuery,
} from "../../store/api/roleApi";
import {
  useGetIikoDepartmentsQuery,
  useGetIspringDepartmentsQuery,
  useGetZupDepartmentsQuery,
} from "../../store/api/departmentApi";
import { useEmployeeTableFilters } from "./useEmployeeTableFilters";
import { getEmployeeTableColumns } from "./EmployeeTableColumns";

export const EployeePage = () => {
  const navigate = useNavigate();

  const [getEmployees, { data: employee, isLoading }] =
    useLazyGetSearchEmployeesQuery();
  const [searchParams, setSearchParams] = useState<
    DownloadExcelParams & { page_number: number; page_size: number }
  >({
    page_number: 1,
    page_size: 10,
  });
  const [openFilterKey, setOpenFilterKey] = useState<string | null>(null);
  const [triggerDownloadExcel] = useLazyDownloadExcelQuery();
  const { getColumnDataPickerProps } = useDatePickerColumn(setSearchParams);
  const { getColumnSearchProps } = useSearchColumn();
  const { data: iikoRoles } = useGetIikoRolesQuery({ enabled: true });
  const { data: iSpringDepartment } = useGetIspringDepartmentsQuery({
    enabled: true,
  });
  const { data: iikoDepartment } = useGetIikoDepartmentsQuery({
    enabled: true,
  });
  const { data: zupDepartment } = useGetZupDepartmentsQuery({ enabled: true });
  const [, setSearchRolesPageNumber] = useState<number>(1);
  const [, setSearchDepartmentPageNumber] = useState<number>(1);

  const { handleTableChange, iikoFilter } =
    useEmployeeTableFilters(setSearchParams);

  const handleDownloadOrders = async () => {
    const {
      name,
      pinfl,
      phone,
      from_date,
      to_date,
      oneczup_role_ids,
      iiko_role_codes,
      ispring_role_ids,
      oneszup_department_ids,
      iiko_department_codes,
      ispring_department_ids,
    } = searchParams;

    const result = await triggerDownloadExcel({
      name,
      pinfl,
      phone,
      from_date,
      to_date,
      oneczup_role_ids,
      iiko_role_codes,
      ispring_role_ids,
      oneszup_department_ids,
      iiko_department_codes,
      ispring_department_ids,
      timeZone: "GMT+05:00",
    });

    if ("data" in result && result.data) {
      const url = window.URL.createObjectURL(result.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "employees.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      console.error("Download error:", result.error);
    }
  };

  useEffect(() => {
    getEmployees(searchParams);
  }, [searchParams]);

  const handleRowClick = (record: Employee) => {
    navigate(`${Paths.employees}/${record.id}`);
  };

  const generateFilters = (data: Employee[] | undefined, dataIndex: string) => {
    if (!data) {
      return [];
    }
    const filterSet = new Set<string>();
    data.forEach((item) => {
      const value = item[dataIndex as keyof Employee];
      if (value) {
        filterSet.add(value.toString());
      }
    });
    return Array.from(filterSet).map((filter) => ({
      text: filter,
      value: filter,
    }));
  };
  const [zupFilter, setZupFilter] = useState<string[] | undefined>(undefined);

  const columns = getEmployeeTableColumns({
    employee: employee?.data.content,
    openFilterKey,
    setOpenFilterKey,
    getColumnDataPickerProps,
    getColumnSearchProps,
    zupFilter,
    setZupFilter,
    setSearchParams,
    setSearchRolesPageNumber,
    setSearchDepartmentPageNumber,
    iikoRoles: iikoRoles?.data,
    iikoFilter,
    zupDepartment: zupDepartment?.data,
    iikoDepartment: iikoDepartment?.data,
    iSpringDepartment: iSpringDepartment?.data,
  });
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <h1>Сотрудники</h1>
        <Button
          onClick={handleDownloadOrders}
          icon={<FileExcelOutlined />}
          size={"large"}
        >
          Скачать заказы в Excel
        </Button>
      </div>
      <Table
        columns={columns as ColumnType<Employee>[]}
        dataSource={employee?.data.content}
        loading={isLoading}
        rowKey="id"
        bordered
        scroll={{ x: 1440 }}
        pagination={{
          current: searchParams.page_number,
          pageSize: searchParams.page_size,
          total: employee?.data?.total_elements,
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
          style: { cursor: "pointer" },
        })}
      />
    </div>
  );
};
